<template>
  <el-dialog title="参会人员会议时间" top="5vh" :visible.sync="visible" width="800px" :close-on-click-modal="false"
    :before-close="closeTab">
    <el-row>
      <el-col class="dateBox">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="今天" name="first"></el-tab-pane>
          <el-tab-pane label="明天" name="second"></el-tab-pane>
          <el-tab-pane label="后天" name="third"></el-tab-pane>
          <el-tab-pane name="fourth">
            <span slot="label" style="width:100px;">
              <el-date-picker v-model="checkDate" size="mini" type="date" :picker-options="startTime"
                format="yyyy-MM-dd" value-format="yyyy-MM-dd" @change="changecheckDate" placeholder="选择日期" />
            </span>
          </el-tab-pane>
        </el-tabs>
        <div class="userList" >
          <div v-loading="loading">
            <div v-for="(userItem, index) in info.userList" :key="index" class="user">
            <div class="userName">{{ userItem.name }}</div>
            <ul>
              <div style="width: 500px;">
                <div v-for="(item, index) in meetTime" :key="index" style="width:40px; float:left;">
                  <span v-if="item.start.split(':')[1] === '00'"
                    style="width:30px; text-align: center;display: block; font-size: 12px;">{{ item.start }}</span>
                  <li :class="{ bg: item.isSelect }"
                    style="display: inline-block; text-align: center; line-height: 44px;position: relative"
                    @click="handleTime(item, index)">
                    <span v-if="tipTab(userItem,item.start)"  @click="tip(userItem[item.start])" style="background: #29d;
                      position: absolute;
                      cursor: pointer;
                      top: 0;
                      width: 100%;
                      height: 100%;
                      left: 0;"></span>
                    <span v-else-if="disabledTab(item.start)" style="
                      position: absolute;
                      top: 0;
                      width: 100%;
                      height: 100%;
                      left: 0;">
                      <img src="../../../../public/static/images/disable.png"
                        style="width: 24px;" />
                    </span>

                  </li>
                  <span v-if="item.start.split(':')[1] === '45'"
                    style="width:30px; text-align: center;display: block; font-size: 12px;">{{ item.end }}</span>
                </div>
              </div>
            </ul>
          </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
// import { add, edit } from '@/api/eCommerceApi/autoCredent/useRightDetail.js'
import { getAttendeesSchedules } from '@/api/secretary.js'
import dayjs from 'dayjs'
export default {
  components: {
  },
  data() {
    return {
      loading: false,
      activeName: 'first',
      checkDate: dayjs().format('YYYY-MM-DD'),
      datcheckDateAfter: dayjs().format('YYYY-MM-DD'),
      startTime: {
        // 用于会议室列表的组件不限制时间选择
        disabledDate: time => {
          const curDate = new Date()// 今天
          const preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000)// 昨天
          return time.getTime() <= preDate
        }
      },
      meetTime: [
        {
          id: 17,
          start: '08:00',
          end: '08:15',
          isSelect: false,
          isClick: false
        },
        {
          id: 21,
          start: '09:00',
          end: '09:15',
          isSelect: false,
          isClick: false
        },
        {
          id: 25,
          start: '10:00',
          end: '10:15',
          isSelect: false,
          isClick: false
        },
        {
          id: 29,
          start: '11:00',
          end: '11:15',
          isSelect: false,
          isClick: false
        },
        {
          id: 33,
          start: '12:00',
          end: '12:15',
          isSelect: false,
          isClick: false
        },
        {
          id: 37,
          start: '13:00',
          end: '13:15',
          isSelect: false,
          isClick: false
        },
        {
          id: 41,
          start: '14:00',
          end: '14:15',
          isSelect: false,
          isClick: false
        },
        {
          id: 45,
          start: '15:00',
          end: '15:15',
          isSelect: false,
          isClick: false
        },
        {
          id: 49,
          start: '16:00',
          end: '16:15',
          isSelect: false,
          isClick: false
        },
        {
          id: 53,
          start: '17:00',
          end: '17:15',
          isSelect: false,
          isClick: false
        },
        {
          id: 57,
          start: '18:00',
          end: '18:15',
          isSelect: false,
          isClick: false
        },
        {
          id: 61,
          start: '19:00',
          end: '19:15',
          isSelect: false,
          isClick: false
        },
        // {
        //   id: 41,
        //   start: '20:00',
        //   end: '20:30',
        //   isSelect: false,
        //   isClick: false
        // },
        // {
        //   id: 43,
        //   start: '21:00',
        //   end: '21:30',
        //   isSelect: false,
        //   isClick: false
        // },
        // {
        //   id: 45,
        //   start: '22:00',
        //   end: '22:30',
        //   isSelect: false,
        //   isClick: false
        // },
        // {
        //   id: 47,
        //   start: '23:00',
        //   end: '23:30',
        //   isSelect: false,
        //   isClick: false
        // },
        // {
        //   id: 2,
        //   start: '00:30',
        //   end: '01:00',
        //   isSelect: false,
        //   isClick: false
        // },
        // {
        //   id: 4,
        //   start: '01:30',
        //   end: '02:00',
        //   isSelect: false,
        //   isClick: false
        // },
        // {
        //   id: 6,
        //   start: '02:30',
        //   end: '03:00',
        //   isSelect: false,
        //   isClick: false
        // },
        // {
        //   id: 8,
        //   start: '03:30',
        //   end: '04:00',
        //   isSelect: false,
        //   isClick: false
        // },
        // {
        //   id: 10,
        //   start: '04:30',
        //   end: '05:00',
        //   isSelect: false,
        //   isClick: false
        // },
        // {
        //   id: 12,
        //   start: '05:30',
        //   end: '06:00',
        //   isSelect: false,
        //   isClick: false
        // },
        // {
        //   id: 14,
        //   start: '06:30',
        //   end: '07:00',
        //   isSelect: false,
        //   isClick: false
        // },
        // {
        //   id: 16,
        //   start: '07:30',
        //   end: '08:00',
        //   isSelect: false,
        //   isClick: false
        // },
        {
          id: 18,
          start: '08:15',
          end: '08:30',
          isSelect: false,
          isClick: false
        },
        {
          id: 22,
          start: '09:15',
          end: '09:30',
          isSelect: false,
          isClick: false
        },
        {
          id: 26,
          start: '10:15',
          end: '10:30',
          isSelect: false,
          isClick: false
        },
        {
          id: 30,
          start: '11:15',
          end: '11:30',
          isSelect: false,
          isClick: false
        },
        {
          id: 34,
          start: '12:15',
          end: '12:30',
          isSelect: false,
          isClick: false
        },
        {
          id: 38,
          start: '13:15',
          end: '13:30',
          isSelect: false,
          isClick: false
        },
        {
          id: 42,
          start: '14:15',
          end: '14:30',
          isSelect: false,
          isClick: false
        },
        {
          id: 46,
          start: '15:15',
          end: '15:30',
          isSelect: false,
          isClick: false
        },
        {
          id: 50,
          start: '16:15',
          end: '16:30',
          isSelect: false,
          isClick: false
        },
        {
          id: 54,
          start: '17:15',
          end: '17:30',
          isSelect: false,
          isClick: false
        },
        {
          id: 58,
          start: '18:15',
          end: '18:30',
          isSelect: false,
          isClick: false
        },
        {
          id: 62,
          start: '19:15',
          end: '19:30',
          isSelect: false,
          isClick: false
        },

        {
          id: 19,
          start: '08:30',
          end: '08:45',
          isSelect: false,
          isClick: false
        },
        {
          id: 23,
          start: '09:30',
          end: '09:45',
          isSelect: false,
          isClick: false
        },
        {
          id: 27,
          start: '10:30',
          end: '10:45',
          isSelect: false,
          isClick: false
        },
        {
          id: 31,
          start: '11:30',
          end: '11:45',
          isSelect: false,
          isClick: false
        },
        {
          id: 35,
          start: '12:30',
          end: '12:45',
          isSelect: false,
          isClick: false
        },
        {
          id: 39,
          start: '13:30',
          end: '13:45',
          isSelect: false,
          isClick: false
        },
        {
          id: 43,
          start: '14:30',
          end: '14:45',
          isSelect: false,
          isClick: false
        },
        {
          id: 47,
          start: '15:30',
          end: '15:45',
          isSelect: false,
          isClick: false
        },
        {
          id: 51,
          start: '16:30',
          end: '16:45',
          isSelect: false,
          isClick: false
        },
        {
          id: 55,
          start: '17:30',
          end: '17:45',
          isSelect: false,
          isClick: false
        },
        {
          id: 59,
          start: '18:30',
          end: '18:45',
          isSelect: false,
          isClick: false
        },
        {
          id: 63,
          start: '19:30',
          end: '19:45',
          isSelect: false,
          isClick: false
        },

        {
          id: 20,
          start: '08:45',
          end: '09:00',
          isSelect: false,
          isClick: false
        },
        {
          id: 24,
          start: '09:45',
          end: '10:00',
          isSelect: false,
          isClick: false
        },
        {
          id: 28,
          start: '10:45',
          end: '11:00',
          isSelect: false,
          isClick: false
        },
        {
          id: 32,
          start: '11:45',
          end: '12:00',
          isSelect: false,
          isClick: false
        },
        {
          id: 36,
          start: '12:45',
          end: '13:00',
          isSelect: false,
          isClick: false
        },
        {
          id: 40,
          start: '13:45',
          end: '14:00',
          isSelect: false,
          isClick: false
        },
        {
          id: 44,
          start: '14:45',
          end: '15:00',
          isSelect: false,
          isClick: false
        },
        {
          id: 48,
          start: '15:45',
          end: '16:00',
          isSelect: false,
          isClick: false
        },
        {
          id: 52,
          start: '16:45',
          end: '17:00',
          isSelect: false,
          isClick: false
        },
        {
          id: 56,
          start: '17:45',
          end: '18:00',
          isSelect: false,
          isClick: false
        },
        {
          id: 60,
          start: '18:45',
          end: '19:00',
          isSelect: false,
          isClick: false
        },
        {
          id: 64,
          start: '19:45',
          end: '20:00',
          isSelect: false,
          isClick: false
        }

        // {
        //   id: 42,
        //   start: '20:30',
        //   end: '21:00',
        //   isSelect: false,
        //   isClick: false
        // },
        // {
        //   id: 44,
        //   start: '21:30',
        //   end: '22:00',
        //   isSelect: false,
        //   isClick: false
        // },
        // {
        //   id: 46,
        //   start: '22:30',
        //   end: '23:00',
        //   isSelect: false,
        //   isClick: false
        // },
        // {
        //   id: 48,
        //   start: '23:30',
        //   end: '24:00',
        //   isSelect: false,
        //   isClick: false
        // }
      ]
    }
  },
  props: {
    info: {
      type: Object,
      default() {
        return {}
      }
    },
    visible: {
      type: Boolean,
      default() { return false }
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
        }
      },
      immediate: true,
      deep: true
    },
    activeName: {
      handler(val) {
        if (val === 'fourth') return
        const dayTemp = {
          first: 0,
          second: 1,
          third: 2
        }
        this.checkDate = dayjs().add(dayTemp[val], 'day').format('YYYY-MM-DD')
      },
      immediate: true
      // deep: true
    },
    checkDate: {
      handler(val) {
        console.log('checkDate')
        this.getAttendeesSchedules(this.generateData(val))
      },
      immediate: true
    }
  },
  methods: {
    generateData(val) {
      const data = {
        workcodes: this.info.userList.map(item => item.username),
        start_time: dayjs(val).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        end_time: dayjs(val).endOf('day').format('YYYY-MM-DD HH:mm:ss')
      }
      return data
    },
    disabledTab(start) {
      if (this.checkDateAfter === dayjs().format('YYYY-MM-DD') && dayjs().format('HH:mm') > start) return true
    },
    tipTab(userItem, start) {
      // 为了减少运算，在此处把需要点击弹框提示tip文字同时存起来
      if (!userItem.time_list?.length) return false
      return userItem.time_list.some((item) => {
        if (dayjs(item.estimate_start_time).format('HH:mm') <= start && dayjs(item.estimate_end_time).format('HH:mm') > start) {
          userItem[start] = item
          return true
        }
      })
    },
    tip(val) {
      this.$alert(`${val.name
      }预约了${val.estimate_start_time}~~~${val.estimate_end_time}`, val.meeting_subject)
    },
    handleTime() { },
    getAttendeesSchedules(data) {
      this.loading = true
      getAttendeesSchedules(data).then(res => {
        this.checkDateAfter = this.checkDate
        this.loading = false
        if (res.code === 'success') {
          this.info.userList.map(item => {
            const tempTime = res.data.find(item1 => item1.workcode === item.username)
            if (tempTime?.time_list?.length) {
              item.time_list = tempTime.time_list
            } else {
              item.time_list = []
            }
            // item.time_list = [
            //   {
            //     name: 'xxx',
            //     meeting_subject: '2023-04-28 集团本部-IT&流程中心-IT部-深圳开发3组  早晚会',
            //     estimate_end_time: '2024-05-09 16:00:00',
            //     estimate_start_time: '2024-05-09 15:00:00'
            //   },
            //   {
            //     name: 'xxx',
            //     meeting_subject: '测试2',
            //     estimate_end_time: '2024-05-09 17:30:00',
            //     estimate_start_time: '2024-05-09 17:00:00'
            //   }
            // ]
          })
        } else {
          this.$message.error(res.message)
          this.info.userList.map(item => { item.time_list = [] })
        }
      })
    },
    closeTab(tag) {
      this.$emit('closeVisible', tag === true)
    },
    handleClick(tab, event) { },
    changecheckDate() { }
  }
}
</script>
<style lang="scss" scoped>
.editForm {

  ::v-deep .el-input,
  .el-select {
    width: 270px;
  }

}

.dateBox {
  margin-left: 20px;
  margin-bottom: 10px;
  z-index: 1;
}

.dateBox .el-input__inner {
  font-weight: 700;
}

.dateBox .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 140px;
}

.userList {
  // margin-left: 30px;
  max-height: 500px;
  overflow-y: scroll;
}

.user {
  border-top: 1px solid #ccc;

  // border-bottom:1px solid #ccc;
  // 最后一个伪类
  &:last-child {
    border-bottom: 1px solid #ccc;
  }

  margin:15px;
  padding:15px 15px 15px 130px;
  overflow: auto;
  // border-radius: 5px;
  // width: 600px;
  word-break: normal;
  position: relative;

  .userName {
    position: absolute;
    top: 45%;
    left: 0;
    width: 130px;
    font-size: 16px;
    font-weight: 500;
    color: #409EFF;
    display: inline-block;
  }

  ul {
    display: inline-block;

    li {
      width: 30px;
      height: 30px;
      list-style: none;
      background: #eee;

    }
  }
}
</style>
